import * as Tone from 'tone';

// Create a volume control
const volumeNode = new Tone.Volume(-10).toDestination();

// Initialize a synth with piano sound
const synth = new Tone.PolySynth(Tone.Synth).connect(volumeNode);

// Define the octave range
const octaveRange = [3, 4, 5];

// Set the volume (value between -60 and 0, where 0 is the loudest)
export const setVolume = (value: number) => {
  volumeNode.volume.value = value;
};

// Map of notes
const allNotes = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];

// Function to get all notes in our piano range
export const getPianoNotes = () => {
  const notes: string[] = [];
  
  octaveRange.forEach(octave => {
    allNotes.forEach(note => {
      notes.push(`${note}${octave}`);
    });
  });
  
  return notes;
};

// Function to determine if a note is a black key
export const isBlackKey = (note: string) => {
  const noteName = note.slice(0, -1); // Remove the octave number
  return noteName.includes('#');
};

// Function to play a note
export const playNote = (note: string) => {
  synth.triggerAttack(note);
};

// Function to stop playing a note
export const stopNote = (note: string) => {
  synth.triggerRelease(note);
};

// Map computer keyboard keys to piano notes
export const keyboardMap: Record<string, string> = {
  // Lower row (Z-M): Octave 2
  'z': 'C2',
  'x': 'D2',
  'c': 'E2',
  'v': 'F2',
  'b': 'G2',
  'n': 'A2',
  'm': 'B2',
  
  // Middle row (A-;): Octave 3
  'a': 'C3',
  'w': 'C#3',
  's': 'D3',
  'e': 'D#3',
  'd': 'E3',
  'f': 'F3',
  't': 'F#3',
  'g': 'G3',
  'y': 'G#3',
  'h': 'A3',
  'u': 'A#3',
  'j': 'B3',
  
  // Upper row (Q-P): Octave 4
  'k': 'C4',
  'o': 'C#4',
  'l': 'D4',
  'p': 'D#4',
  ';': 'E4',
  "'": 'F4',
  ']': 'F#4',
  '\\': 'G4',
  
  // Number row: Octave 5
  '1': 'A4',
  '2': 'B4',
  '3': 'C5',
  '4': 'D5',
  '5': 'E5',
  '6': 'F5',
  '7': 'G5',
  '8': 'A5',
  '9': 'B5',
  '0': 'C6',
  '-': 'D6',
  '=': 'E6',
};
